import { render, staticRenderFns } from "./BranchAdmin.vue?vue&type=template&id=39b5a913&scoped=true"
import script from "./BranchAdmin.vue?vue&type=script&lang=js"
export * from "./BranchAdmin.vue?vue&type=script&lang=js"
import style0 from "./BranchAdmin.vue?vue&type=style&index=0&id=39b5a913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b5a913",
  null
  
)

export default component.exports